<template>
  <div>
    <page-header
     :back="true"
      heading="Contact Information"
      breadcrumb="Settings >> Contact Information"
    />
    <div class="shadow rounded w-full mx-auto text-darkBlue mt-8 mb-8">
      <div class="banner pt-16 pl-6">
        <!-- <div class="">
          <img
            :src="getProfileImage"
            alt="profile picture"
            class="w-32 h-32 img-fluid cursor-pointer"
          />
        </div> -->
        <!-- </div> -->
        <div
          class="imagePreviewWrapper"
          :style="{
            'background-image':
              getProfileImage != ''
                ? `url(${getProfileImage})`
                : 'url(' +
                  require('@/assets/images/settings/img-placeholder.png') +
                  ')',
          }"
        >
          <!-- 
      <img
        src="@/assets/images/onboarding/upload-img-icon.png"
        class="img-fluid img-upload-icon"
        alt="image upload icon"
      /> -->
        </div>
      </div>
      <form @submit.prevent class="py-12 px-6 bg-white">
        <div class="flex justify-end relative">
          <svg
            @click="showPictureModal = true"
            width="30"
            height="31"
            viewBox="0 0 30 31"
            class="img-upload-icon"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="15" cy="15.5" r="15" fill="#FCC210" />
            <g clip-path="url(#clip0)">
              <path
                d="M21.1665 19.1683C21.1665 19.3893 21.0787 19.6013 20.9224 19.7575C20.7661 19.9138 20.5542 20.0016 20.3332 20.0016H10.3332C10.1122 20.0016 9.9002 19.9138 9.74391 19.7575C9.58763 19.6013 9.49984 19.3893 9.49984 19.1683V14.1683C9.49984 13.9473 9.58763 13.7353 9.74391 13.579C9.9002 13.4228 10.1122 13.335 10.3332 13.335H11.3098C11.9725 13.3346 12.608 13.0711 13.0765 12.6025L13.7682 11.9125C13.924 11.7566 14.1353 11.6688 14.3557 11.6683H16.309C16.53 11.6683 16.7419 11.7562 16.8982 11.9125L17.5882 12.6025C17.8204 12.8347 18.096 13.019 18.3995 13.1446C18.7029 13.2703 19.0281 13.335 19.3565 13.335H20.3332C20.5542 13.335 20.7661 13.4228 20.9224 13.579C21.0787 13.7353 21.1665 13.9473 21.1665 14.1683V19.1683ZM10.3332 12.5016C9.89114 12.5016 9.46722 12.6772 9.15466 12.9898C8.8421 13.3023 8.6665 13.7263 8.6665 14.1683V19.1683C8.6665 19.6103 8.8421 20.0342 9.15466 20.3468C9.46722 20.6594 9.89114 20.835 10.3332 20.835H20.3332C20.7752 20.835 21.1991 20.6594 21.5117 20.3468C21.8242 20.0342 21.9998 19.6103 21.9998 19.1683V14.1683C21.9998 13.7263 21.8242 13.3023 21.5117 12.9898C21.1991 12.6772 20.7752 12.5016 20.3332 12.5016H19.3565C18.9145 12.5015 18.4907 12.3259 18.1782 12.0133L17.4882 11.3233C17.1757 11.0107 16.7518 10.8351 16.3098 10.835H14.3565C13.9145 10.8351 13.4907 11.0107 13.1782 11.3233L12.4882 12.0133C12.1757 12.3259 11.7518 12.5015 11.3098 12.5016H10.3332Z"
                fill="#383F51"
              />
              <path
                d="M15.333 18.335C14.7805 18.335 14.2506 18.1155 13.8599 17.7248C13.4692 17.3341 13.2497 16.8042 13.2497 16.2516C13.2497 15.6991 13.4692 15.1692 13.8599 14.7785C14.2506 14.3878 14.7805 14.1683 15.333 14.1683C15.8855 14.1683 16.4154 14.3878 16.8061 14.7785C17.1968 15.1692 17.4163 15.6991 17.4163 16.2516C17.4163 16.8042 17.1968 17.3341 16.8061 17.7248C16.4154 18.1155 15.8855 18.335 15.333 18.335ZM15.333 19.1683C16.1066 19.1683 16.8484 18.861 17.3954 18.314C17.9424 17.767 18.2497 17.0252 18.2497 16.2516C18.2497 15.4781 17.9424 14.7362 17.3954 14.1892C16.8484 13.6423 16.1066 13.335 15.333 13.335C14.5595 13.335 13.8176 13.6423 13.2706 14.1892C12.7236 14.7362 12.4163 15.4781 12.4163 16.2516C12.4163 17.0252 12.7236 17.767 13.2706 18.314C13.8176 18.861 14.5595 19.1683 15.333 19.1683ZM11.1663 14.585C11.1663 14.6955 11.1224 14.8014 11.0443 14.8796C10.9662 14.9577 10.8602 15.0016 10.7497 15.0016C10.6392 15.0016 10.5332 14.9577 10.455 14.8796C10.3769 14.8014 10.333 14.6955 10.333 14.585C10.333 14.4745 10.3769 14.3685 10.455 14.2903C10.5332 14.2122 10.6392 14.1683 10.7497 14.1683C10.8602 14.1683 10.9662 14.2122 11.0443 14.2903C11.1224 14.3685 11.1663 14.4745 11.1663 14.585Z"
                fill="#383F51"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="13.3333"
                  height="13.3333"
                  fill="white"
                  transform="translate(8.6665 9.16797)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-md-12 col-lg-6">
              <div class="px-3">
                <label class="label">First Name</label>
                <base-input v-model="accountOwner.firstname" />
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6">
              <div class="px-3">
                <label class="label">Last Name</label>
                <base-input v-model="accountOwner.lastname" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-12 col-lg-6">
              <div class="px-3">
                <label class="label">Email Address</label>
                <base-input :disabled="true" class="cursor-not-allowed text-gray-500" v-model="accountOwner.email" />
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6">
              <div class="px-3">
                <label class="label">Gender</label>
                <el-select v-model="accountOwner.gender" placeholder="">
                  <el-option
                    v-for="gender in genders"
                    :key="gender"
                    :label="gender"
                    :value="gender"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-12 col-lg-6">
              <div class="px-3 py-3">
                <div class="w-full flex">
                  <label class="label whitespace-no-wrap">Mobile Number</label>
                  <div class="w-full flex mt-1 gap-4 justify-end">
                    <div>
                      <label for="firstYes" class="radio-label">
                        <input
                          class="bg-primary-yellow text-secondary-yellow"
                          name="first"
                          type="radio"
                          id="firstYes"
                          value="No"
                          v-model="routeEnd"
                        />
                        Mobile
                        <span></span>
                      </label>
                    </div>

                    <div>
                      <label for="firstNo" class="radio-label">
                        <input
                          type="radio"
                          v-model="routeEnd"
                          value="Yes"
                          id="firstNo"
                          name="first"
                        />
                        Fixed
                        <span></span>
                      </label>
                    </div>
                  </div>
                </div>
                <vue-tel-input
                :allowNumericInput="false"
                @input="phoneNumberChange"
                :preferredCountries="['Nigeria']"
                v-model="accountOwner.mobile_no"
              ></vue-tel-input>
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6">
              <div class="px-3 py-3">
                <div class="flex items-center">
                  <label class="label">Address</label>
                  <div class="w-full flex mt-1 gap-4 justify-end">
                    <div>
                      <label for="address" class="radio-label">
                        <input
                          class="bg-primary-yellow text-secondary-yellow"
                          name="address"
                          type="radio"
                          id="address"
                          value="No"
                          v-model="routeEnd"
                        />
                        Residential
                        <span></span>
                      </label>
                    </div>

                    <div>
                      <label for="address2" class="radio-label">
                        <input
                          type="radio"
                          v-model="routeEnd"
                          value="Yes"
                          id="address2"
                          name="address"
                        />
                        Business
                        <span></span>
                      </label>
                    </div>
                  </div>
                </div>

                <vue-google-autocomplete
                  id="map2"
                  ref="address"
                  classname="input"
                  placeholder="Enter address"
                  :value="fullAddress"
                  v-on:placechanged="setAddress"
                >
                </vue-google-autocomplete>
              </div>
            </div>
          </div>
        </div>

        <div class="my-2 mx-3">
          <base-checkbox
            label="Send me status updates regarding my shipment with the email provided."
          />
        </div>
        <div class="flex justify-between mx-3">
          <base-button
            text="Cancel"
            background="#DAE8F6"
            p="py-2 px-8"
            @click="$router.go(-1)"
          />
          <base-button
            text="Save"
            p="py-2 px-8"
            :loading="loading"
            @click="updateUser"
          />
        </div>
      </form>
    </div>
    <picture-modal
      :image="getProfileImage"
      @completed-picture-update="findUserDetails"
      :showModal="showPictureModal"
      @close-modal="showPictureModal = false"
    />
  </div>
</template>

<script>
import PageHeader from "../PageHeader.vue";
import VueGoogleAutocomplete from "vue-google-autocomplete";
// import timezones from "@/utilities/timezones";
import PictureModal from "./PictureModal.vue";

export default {
  components: {
    PageHeader,
    VueGoogleAutocomplete,
    PictureModal,
  },
  data() {
    return {
      accountOwner: {
        address: {
          name: "",
          lat: "",
          lng: "",
          street_number: "",
          adm_1: "",
          adm_2: "",
        },
        firstname: "",
        lastname: "",
        gender: "",
        mobile_no: "",
        email: "",
        imageurl: "",
        country: "",
      },
      genders: ["Male", "Female"],
      languages: ["English"],
      loading: false,
      savingAccountOwnerInfo: false,
      totalSteps: "3",
      stepNo: "3",
      accountType: null,
      isUploadingImage: false,
      showPictureModal: false,
    };
  },
  computed: {
    fullAddress() {
      return this.extractAddress(this.accountOwner.address);
    },
    getProfileImage() {
      return this.accountOwner.imageurl != " "
        ? this.accountOwner.imageurl
        : require("@/assets/images/settings/img-placeholder.png");
      // return this.accountOwner.imageurl ;
    },
  },
  mounted() {
    this.findUserDetails();
  },
  methods: {
    phoneNumberChange(val){
      const pattern = /[a-zA-Z!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/g;
      const result = val.replace(pattern, '');
      this.$nextTick(() => {
        this.accountOwner.mobile_no = result;
      });
    },
    async findUserDetails() {
      try {
        let response = await this.$_findUserDetails();
        this.accountOwner = response.data.data;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async updateUser() {
      this.loading = true;
      this.deleteExcessData();
      // endpoint expects userId not id
      this.accountOwner.userId = this.accountOwner.id;
      try {
        let response = await this.$_saveAccountOwnerInformation({
          user: this.accountOwner,
        });
        this.loading = false;
        if (!response.data.data.user) return;
        this.$store.dispatch("saveUserDetails", response.data.data.user);
        this.generateToast("Your information has been updated!", "success");
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    deleteExcessData() {
      // removes the unneeded properties from the user object
      delete this.accountOwner.Org;
      delete this.accountOwner.createdAt;
      delete this.accountOwner.passwordauth;
      delete this.accountOwner.updatedAt;
      delete this.accountOwner.twoFA;
      delete this.accountOwner.securityques;
      delete this.accountOwner.onboardingtype;
      delete this.accountOwner.salt;
      delete this.accountOwner.hash;
      delete this.accountOwner.accounttype;
      delete this.accountOwner.answer;
    },
    setAddress(addressData) {
      this.accountOwner = {
        ...this.accountOwner,
        address: {
          name: addressData?.route,
          lat: addressData?.latitude,
          lng: addressData?.longitude,
          street_number: addressData?.street_number,
          locality: addressData?.locality,
          country: addressData.country,
          adm_1: addressData?.administrative_area_level_1,
          adm_2: addressData?.administrative_area_level_2,
        },
      };
      console.log(this.accountOwner);
    },
  },
};
</script>

<style scoped>
.banner {
  width: 100%;
  height: 9rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @apply bg-primary-navy;
}

.imagePreviewWrapper {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: block;
  cursor: pointer;
  border: 4px solid white;
  background-image: url("../../../assets/images/settings/blank-profile-picture.png");
  /* margin: 0 auto; */
  background-size: cover;
  background-position: center center;
}

.img-upload-icon {
  position: absolute;
  @apply cursor-pointer;
  right: 0;
  top: -2rem;
}
</style>
